import { isUuid } from '@notifi/uuid/validate';
import { PURCHASING_FLAGS } from '@notifi/shared-types/feature-flags';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { RequireFeatureFlag } from '@/features/feature-flags/RequireFeatureFlag';

/** Every purchasing page sits behind the purchasing flag (PLAT-FF-1). */
function PurchasingArea() {
  return (
    <RequireFeatureFlag flag={PURCHASING_FLAGS.purchaseOrders} title="Purchasing">
      <Outlet />
    </RequireFeatureFlag>
  );
}
import { statuses, type OrderStatus } from '@/features/purchasing/api';

/** Order lists the dashboard's tiles open (PUR-RPT-1, -2). */
export type OrderQueue = 'AWAITING_DELIVERY' | 'OVERDUE' | 'FIELD_REVIEW';
const QUEUES: OrderQueue[] = ['AWAITING_DELIVERY', 'OVERDUE', 'FIELD_REVIEW'];

export const Route = createFileRoute('/_dashboard/dashboard/purchasing')({
  validateSearch: (
    search: Record<string, unknown>,
  ): {
    jobId?: string;
    orderId?: string;
    billId?: string;
    supplierId?: string;
    status?: OrderStatus;
    queue?: OrderQueue;
    /** Open straight into a new order (from a job's "New purchase order"). */
    create?: boolean;
    /** How the order was reached: from its supplier's page or its pick list, the trail leads back there. */
    via?: 'supplier' | 'pick-list';
  } => ({
    via:
      search.via === 'supplier' ? 'supplier' : search.via === 'pick-list' ? 'pick-list' : undefined,
    billId: isUuid(search.billId) ? (search.billId as string) : undefined,
    supplierId: isUuid(search.supplierId) ? (search.supplierId as string) : undefined,
    orderId: isUuid(search.orderId) ? (search.orderId as string) : undefined,
    jobId: isUuid(search.jobId) ? (search.jobId as string) : undefined,
    status:
      typeof search.status === 'string' && search.status in statuses
        ? (search.status as OrderStatus)
        : undefined,
    queue: QUEUES.includes(search.queue as OrderQueue) ? (search.queue as OrderQueue) : undefined,
    create: search.create === true || search.create === 'true' ? true : undefined,
  }),
  component: PurchasingArea,
});
